var _rect, _rect2, _path, _path2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmploymentTaxCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#EAEAF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C11 18.1144 11 17.1716 11.5858 16.5858C12.1716 16 13.1144 16 15 16H25C26.8856 16 27.8284 16 28.4142 16.5858C29 17.1716 29 18.1144 29 20V24C29 25.8856 29 26.8284 28.4142 27.4142C27.8284 28 26.8856 28 25 28H15C13.1144 28 12.1716 28 11.5858 27.4142C11 26.8284 11 25.8856 11 24V20Z",
    stroke: "#161616",
    strokeWidth: 1.335
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16L25.539 14.9243C25.0351 13.7485 24.7831 13.1606 24.2822 12.8303C23.7812 12.5 23.1416 12.5 21.8624 12.5H15C13.1144 12.5 12.1716 12.5 11.5858 13.0858C11 13.6716 11 14.6144 11 16.5V23",
    stroke: "#161616",
    strokeWidth: 1.335
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 19,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentTaxCalculator);
export default __webpack_public_path__ + "static/media/employment-tax-calculator.fc156ace815ee7d5fb82c85664f87deb.svg";
export { ForwardRef as ReactComponent };